<template>
  <div>
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click="nav = !nav">
        <v-icon>mdi-menu</v-icon>
      </v-app-bar-nav-icon>

      <v-progress-linear absolute bottom indeterminate color="light-blue" v-if="loading"></v-progress-linear>

      <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="signout" icon><v-icon>mdi-logout</v-icon></v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="nav" app>
      <v-list nav>
        <v-list-item>
          <v-list-item-avatar>
            <v-img src="@/assets/user.png"></v-img>
          </v-list-item-avatar>

          <span>{{ $store.state.user.info.username }}</span>
        </v-list-item>

        <v-divider></v-divider>

        <template v-for="(item, index) in navItems">
          <v-list-item v-if="!item.visible || item.visible()" :key="index" :to="item.to">
            <v-list-item-content>
              {{ item.title }}
            </v-list-item-content>
          </v-list-item>
        </template>

      </v-list>
    </v-navigation-drawer>

    <v-content class="white">
      <slot></slot>
    </v-content>

    <v-footer color="primary" dark class="py-2 justify-center" app>
      ©COPYRIGHT LOOP.
    </v-footer>
  </div>
</template>

<script>
export default {
  data () {
    return {
      nav: null,
      navItems: [
        {
          title: '회사 관리',
          to: '/companies',
          visible: () => this.isAdmin
        },
        {
          title: '사용자 관리',
          to: '/users',
          visible: () => this.isAdmin
        },
        {
          title: '장치 관리',
          to: '/devices'
        },
        {
          title: '태그 관리',
          to: '/tags'
        },
        {
          title: '운행 기록',
          to: '/days'
        },
        {
          title: '펌웨어 관리',
          to: '/firmwares',
          visible: () => this.isAdmin
        },
        {
          title: '패킷 조회',
          to: '/packets',
          visible: () => this.isAdmin
        },
        {
          title: '에러 조회',
          to: '/errors',
          visible: () => this.isAdmin
        }
      ]
    }
  },
  computed: {
    loading () {
      return this.$store.state.loading
    },
    isAdmin () {
      return this.$store.getters['user/isAdmin']
    }
  },
  methods: {
    async signout () {
      try {
        await this.$store.dispatch('user/signout')
      } catch (err) {
        alert(err.message)
      } finally {
        location.href = '/signin'
      }
    }
  }
}
</script>
